// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/quality-control/${file}.vue`);

export default [
  // Complaints
  {
    path: "/customer-complaints",
    name: "complaints-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerComplaints",
    },
    components: {
      content: lazyLoad("complaint-list"),
    },
  },
  {
    path: "/customer-complaints/create*",
    name: "complaints-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
  {
    path: "/customer-complaints/edit/:id*",
    name: "complaints-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
  {
    path: "/customer-complaints/review/:id*",
    name: "complaints-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerComplaints",
    },
    components: {
      content: lazyLoad("complaint-detail"),
    },
  },
];
